import { z } from 'zod';

import { PositionSchema } from './position';
import { AfcSubmissionCandidateOpportunitySchema } from './afc-submission-candidate-opportunity';

export const AfcSubmissionPositionSchema = PositionSchema.pick({
  billingHoursPerDay: true,
  billingHoursPerWeek: true,
  billingUnitsPerWeek: true,
  description: true,
  estimatedEngagementTotalMonths: true,
  id: true,
  name: true,
  role: true,
  reservedType: true,
  talentExperienceYears: true,
  worksite: true,
}).extend({
  candidateOpportunities: z.array(AfcSubmissionCandidateOpportunitySchema),
});

export type AfcSubmissionPosition = z.infer<typeof AfcSubmissionPositionSchema>;
